import React from 'react';

// Components
import Advertisement from '../Advertisement/Advertisement';
import Loader, { LoaderColors } from '../Loader/Loader';
import VideoList, { IVideoItem } from '../VideoList/VideoList';

import { ReactComponent as ArrowRight } from '../../assets/arrow_right-24px.svg';

// Config
import {
  getPortraitById,
  getProfileUrlById,
} from '../../config';

// Utils
import {
  getPlaybackVideos,
  IBrightcovePlaybackVideo,
} from '../../util/brightcove-api';
import { classList } from '../../util/util';

// Types
import {
  AdvertisementVariant,
  AnglerId,
  IAoyTournament,
  IAoyTournamentTMS,
} from '../../types';

// Hooks
import { useAoyAngler } from '../../hooks';
import { isEmpty } from 'lodash';

export const withHooksHOC = (Component: any) => {
  return (props: any) => {
    const anglerAoyData = useAoyAngler(props.anglerId, props.year, props.type);
    return <Component year={props.year} aoyData={anglerAoyData} {...props} />;
  };
};
interface IProps {
  anglerId: AnglerId;
  anglerName: string;
  count: number;
  aoyData: IAoyTournament[] | IAoyTournamentTMS[];
  year: number;
  type: string;
}
interface IState {
  latestVideos: IVideoItem[];
  loading: boolean;
  portraitLoading: boolean;
}

/**
 * Renders the expanded angler row when a row is clicked
 */
class AOYExpanded extends React.PureComponent<IProps, IState> {
  public state: IState = {
    latestVideos: [],
    loading: true,
    portraitLoading: true,
  };

  videoSubscription = {
    isActive: false,
    subscription: null,
  };

  videoPlaybackQueryTimer: any = null;

  public currentYear = new Date().getFullYear();

  public getLatestVideos = () => {
    const { anglerName } = this.props;

    if (anglerName) {
      this.videoSubscription.isActive = true;

      getPlaybackVideos(anglerName).then(res => {
        if (this.videoSubscription.isActive) {
          const parsedVideos = res.videos.map(
            (video: IBrightcovePlaybackVideo) => ({
              alt: video.name,
              image: video.poster,
              title: video.name,
              videoId: video.id,
            })
          );

          this.setState({ latestVideos: parsedVideos, loading: false });
        }
      });
    }
  };

  public setLatestVideos = (latestVideos: IVideoItem[]) =>
    this.setState({
      latestVideos,
      loading: false,
    });

  public portraitLoaded = () => this.setState({ portraitLoading: false });

  public async componentDidMount() {
    this.getLatestVideos();

    /**
     * @TODO figure out business logic for how frequently we want to requery the videoPlayback API
     */
    this.videoPlaybackQueryTimer = setInterval(this.getLatestVideos, 60 * 1000);
  }

  public componentWillUnmount() {
    if (this.videoPlaybackQueryTimer) {
      clearInterval(this.videoPlaybackQueryTimer);
      this.videoPlaybackQueryTimer = null;
    }
  }

  public addDefaultSrc(ev){
    ev.target.src = 'https://www.bassmaster.com/sites/default/files/styles/panopoly_image_original/public/bassshield_4c.png';
  }

  public render() {
    const { loading, latestVideos, portraitLoading } = this.state;

    const { anglerId, anglerName, count, aoyData, year } = this.props;

    /**
     * @todo get a smaller image that fits this box
     */
    const portrait = getPortraitById(anglerId);
    const profile = getProfileUrlById(anglerId);

    return (
      <div className="angler-expanded" itemID={`${count + 1}`}>
        <div className="angler-expanded__left">
          <div className="angler-profile">
            <Loader loading={portraitLoading} color={LoaderColors.LIGHT} />
            <img
              src={portrait}
              alt="Portrait of angler"
              onLoad={this.portraitLoaded}
              onError={this.addDefaultSrc}
            />
            <div
              className={classList(
                'angler-profile__link--button',
                portraitLoading && 'angler-profile__link--hidden'
              )}
            >
              <a target="_blank" href={profile}>
                Angler Information
                <ArrowRight width="32" />
              </a>
            </div>
          </div>
        </div>
        <div className="angler-expanded__middle">
          <div className="angler-expanded__container">
            { aoyData && !isEmpty(aoyData) ? (
              <>
                <div className="angler-expanded-tournament-heading">{year} TOURNAMENTS</div>
                <div>
                  <div className="angler-expanded-tournament-header">
                    <div className="angler-expanded-tournament-place">
                      Place
                    </div>
                    <div className="angler-expanded-tournament-title">
                      Tournament
                    </div>
                    <div className="angler-expanded-tournament-weight">
                      Points
                    </div>
                  </div>

                  {aoyData.map(aoy => (

                    <div className="angler-expanded-tournament">
                      <div className="angler-expanded-tournament-place">
                        {aoy.place}
                      </div>
                      <div className="angler-expanded-tournament-title">
                        <a href={aoy.URL}>{aoy.Title}</a>

                      </div>
                      <div className="angler-expanded-tournament-weight">
                        {aoy.Points}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : ''}

            <div className="angler-videos">
              {!loading ? (
                <VideoList anglerName={anglerName || ''} items={latestVideos} />
              ) : (
                <Loader loading={loading} color={LoaderColors.LIGHT} />
              )}
            </div>
          </div>
        </div>
        <div className="angler-expanded__right">
          <div>
            <Advertisement
              variant={AdvertisementVariant.BOX}
              count={count + 1}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withHooksHOC(AOYExpanded);
